import {
    REGULAR,
    SUPPLY_CHAIN,
} from "@/Support/Constants/supplyChainStatus.js";
import { usePage } from "@inertiajs/vue3";
import axios from "axios";

import getQuery from "./getQuery";

export function sanitizeInput(value = "", decimalPlaces = 2) {
    if (!value) {
        return value;
    }
    // Use a regular expression to remove non-numeric characters
    value = value.replace(/[^\d.]/g, "");
    const parts = value.split(".");
    parts.splice(2); // avoid multiple decimal point dots inside a number
    if (parts[0]) {
        parts[0] = parseInt(parts[0]).toString();
    }
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    if (parts.length > 1) {
        parts[1] = parts[1].substring(0, decimalPlaces);
    }
    value = parts.join(".");
    return value;
}

export function formatInput(event, symbol = "£") {
    return symbol + sanitizeInput(event);
}

export function formatInputNoSymbol(event) {
    return sanitizeInput(event);
}

export function formatToCurrency(value, decimals = 2) {
    if (value === null || value === false) {
        return value;
    }

    let sign = "";
    if (value < 0) {
        sign = "-";
        value *= -1;
    }

    return `${sign}£${Intl.NumberFormat("en-gb", { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(value)}`;
}

export function formatWithDecimalPrecision(
    value,
    isCurrency,
    minDecimals = 2,
    maxDecimals = 2,
) {
    if (!value) {
        return value;
    }
    const currencySymbol = isCurrency ? "£" : "";
    const formattedValue = Intl.NumberFormat("en-gb", {
        minimumFractionDigits: minDecimals,
        maximumFractionDigits: maxDecimals,
    }).format(value);
    return currencySymbol + formattedValue;
}

export function truncateString(str, num = 25) {
    if (str.length <= num) {
        return str;
    }
    return str.slice(0, num) + "...";
}

export function convertStringToNumeric(str) {
    if (str && typeof str === "string") {
        str = str.replace(/[^\d.]/g, "");
    } else if (str === "") {
        str = 0;
    }

    return Number(str);
}
export function transformStringToNumeric(data, numericFields) {
    for (const field of numericFields) {
        if (data[field] && typeof data[field] === "string") {
            data[field] = data[field].replace(/[^\d.]/g, "");
        } else if (data[field] === "") {
            data[field] = 0;
        }
    }
    return data;
}

export function intlFormatNumber(value, options = {}) {
    const formattedNumber = new Intl.NumberFormat("en-GB", options).format(
        value,
    );
    return formattedNumber.toLowerCase();
}

export const tooltipTruncationLength = 35;
export function truncateTooltip(string) {
    if (string.length < tooltipTruncationLength) {
        return string;
    }
    let firstLine = string
        .substring(0, tooltipTruncationLength)
        .split(" ")
        .slice(0, -1)
        .join(" ");
    let secondLine = string.substring(firstLine.length);
    if (secondLine.length > tooltipTruncationLength) {
        secondLine = secondLine.substring(0, tooltipTruncationLength) + "...";
    }
    return `${firstLine}\n${secondLine}`;
}

export const sortedEquality = (left, right) => {
    Object.values(left).map((values) =>
        Array.isArray(values) ? values.sort() : values,
    );
    Object.values(right).map((values) =>
        Array.isArray(values) ? values.sort() : values,
    );

    return JSON.stringify(left) === JSON.stringify(right);
};

export const defaultSearchValue = () => {
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("search")) {
        return urlParams.get("search");
    }
    return "";
};

export const getPercentage = (scope, metricDetail) => {
    let percentage = 0;
    if (metricDetail["carbon_scope_" + scope] > 0) {
        percentage =
            (metricDetail["carbon_scope_" + scope] /
                metricDetail["target_carbon_scope_" + scope]) *
            100;
    }
    return percentage.toFixed(2);
};

export const globalLoading = (value) => {
    usePage().props.pageLoaderState = value ? 1 : 0;
};

export const fetchHeadlineFigures = async (
    abortController,
    filters,
    supplyChain = false,
    activityUuid = null,
) => {
    let summary = [];
    await axios
        .get(
            route("dashboard.headline-figures", {
                filter: filters,
                status: supplyChain ? SUPPLY_CHAIN : REGULAR,
                activity_uuid: activityUuid,
            }),
            {
                signal: abortController.signal,
            },
        )
        .then((response) => {
            summary = response.data;
        });
    return summary;
};

export function extractPageParam(url) {
    return getQuery(["page"], url)["page"];
}
